import { formatDecimalPlace } from "common/formatters";
import React from "react";

const BasisColumn: React.FC<{value: number, isFixed: boolean}> = React.memo(props => {
    return props.value == null
        ? <>--</>
        : <span>{props.isFixed && <i className="material-icons lock-icon">lock</i>}{formatDecimalPlace(props.value)}</span>;
});

export default BasisColumn;